import React from 'react'
import {useNavigate } from 'react-router-dom'
import LogoPaimentFacture from '../../assets/iconTsx/logoPaimentFacture'
import LogoTransferBancaire from '../../assets/iconTsx/logoTransferBancaire'
import LogoTransfer from '../../assets/iconTsx/logoTransfer'
import LogoRecharge from '../../assets/iconTsx/logoRecharge'
import LogoAssurance from '../../assets/iconTsx/logoAssurance'
import LogoCartePrepayee from '../../assets/iconTsx/logoRechargePrepayee'
import LogoWallet from 'assets/iconTsx/logoWallet'
import logoESim from '../../assets/iconTsx/logoESim'
import IConBientot from '../../assets/badget/bientot.png'
import IconExclusive from '../../assets/badget/exclusiveEN.png'
import IconzeroFrais from '../../assets/badget/zeroFraisEN.png'
import IconTopVente from '../../assets/badget/topVenteRechargeEN.png'
import IconTopVenteTransfert from '../../assets/badget/topVenteTransferEN.png'
import { useTranslation } from 'react-i18next'


const homeBlockLinks: React.FC = () => {

  const {t}= useTranslation()

  let badget 
  switch( t("languages.code")) 
  {
  case 'FR':
    badget= ''
  break
  case 'EN':
     badget= 'anglais' 
  break
  }

  const list: {
     image: string |React.ElementType ,
      linkTo: string; text: string , 
      backgroundColor: string, 
      colorFlech:string,
      bientot?:boolean
      hover?: string,
      Badges?: string,
      colorBadges?:string,
      iconBadges?: string 
    }[] = [
    { image: LogoTransfer, linkTo: '/transfert/0', text: t("ServiceList.cashTransfer"), backgroundColor:'#E6E6FB', colorFlech:'text-[#5754E5] group-hover:text-[#4D36CC]', hover:'group-hover:fill-[#4D36CC] xl:w-[55] xl:h-[55px] sm:w-[42] sm:h-[42px]', iconBadges:IconTopVenteTransfert},
    { image: LogoPaimentFacture, linkTo: '/paimentFacture', text: t("ServiceList.billPayment"), backgroundColor: '#E1F6FF' ,  colorFlech:'text-[#38C3FF] group-hover:text-[#33B0E6]', hover:'group-hover:fill-[#33B0E6] xl:w-[55] xl:h-[55px] sm:w-[42] sm:h-[42px]', iconBadges:IconExclusive},

    { image: LogoTransferBancaire, linkTo: '/transfert/1', text: t("ServiceList.bankTransfer") , backgroundColor:'#DEF6EA',  colorFlech:'text-[#20C374] group-hover:text-[#1DB069]' , hover:'group-hover:fill-[#1DB069] ', iconBadges:IconzeroFrais },
    { image: LogoCartePrepayee, linkTo: '/rechargeCartePrepayee', text: t("ServiceList.prepaidCardRecharge") , backgroundColor: '#FFE3DB',  colorFlech:'text-[#FF6C47] group-hover:text-[#FF5E36]', hover:'group-hover:fill-[#FF5E36] xl:w-[55] xl:h-[55px] sm:w-[42] sm:h-[42px]' },
    { image: LogoWallet, linkTo: '/transfert-vers-wallet', text: t("ServiceList.walletTransfer"), backgroundColor: '#FFE8CD' ,  colorFlech:'text-[#B28858] group-hover:text-[#9D7241]', hover:'group-hover:fill-[#9D7241] xl:w-[55] xl:h-[55px] sm:w-[42] sm:h-[42px]' },
    { image: LogoAssurance, linkTo: '/assurance', text: t("ServiceList.localInsurance"), backgroundColor: '#FFEBF7' ,  colorFlech:'text-[#FF76C8] group-hover:text-[#E66AB4]', hover:'group-hover:fill-[#E66AB4] xl:w-[55] xl:h-[55px] sm:w-[42] sm:h-[42px]'  },
    { image: LogoRecharge, linkTo: '/recharge', text: t("ServiceList.mobileRecharge"), backgroundColor:'#FFF6D9' ,  colorFlech:'text-[#FFC000] group-hover:text-[#E6AD00]' , hover:'group-hover:fill-[#E6AD00] xl:w-[55] xl:h-[55px] sm:w-[42] sm:h-[42px]', iconBadges:IconTopVente },

    // { image: LogoAssurance, linkTo: '/', text: 'Souscription assurance locale ',backgroundColor: '' ,  colorFlech:'', bientot: true, hover:'fill-[#9EA2AE] sm:w-[42] sm:h-[42px]'},
    // { image: LogoPaimentFacture, linkTo: '/', text: 'Paiement de factures locales ',backgroundColor: '' ,  colorFlech:'', bientot: true, hover:'fill-[#9EA2AE] sm:w-[42] sm:h-[42px]'},
    { image: logoESim, linkTo: '/', text: t("ServiceList.eSim"),backgroundColor: '' ,  colorFlech:'', bientot: true, hover:'fill-[#DDDDDD] xl:w-[55] xl:h-[55px] sm:w-[42] sm:h-[42px]', iconBadges:IConBientot},
  ]

  
  const navigate = useNavigate()
  return (
    <div className="grid grid-cols-2 gap-[24px] lg:gap-4  items-center ">
      {list.map((item, index) => {
        const ImageComponent = item.image
    return(
      <div key={index}  onClick={()=>{navigate(item?.linkTo)}}
      className={`${item.bientot ? ' bg-[#FAFAFA] cursor-not-allowed' : 'lg:bg-[#F2F2F2] bg-[#FFF] cursor-pointer'}  shadow-[0px_5px_22px_-4px_rgba(0,0,0,0.1)] sm:shadow-none sm:rounded-[10px]  rounded-[8px]
          h-[120px] w-full p-[25px] 3xl:p-2 xl:p-[25px] group sm:p-2 flex items-center sm:items-start justify-between sm:flex-col relative`}
      >
        {/* <div className='flex justify-between sm:flex-col items-center'> */}
          <div className='flex gap-4 sm:gap-2 items-center sm:items-start sm:flex-col w-[80%] sm:w-full'>
           <div className='w-[60px] sm:w-[43px] h-auto sm:-ml-[10px] '> <ImageComponent styleCssImage={` ${item.hover}` }/></div>
            <h2 className={` ${item.bientot && 'text-[#D7D7D7]'} text-[14px] xl:text-[14px] 2xl:text-[12px] font-semibold `}>{item.text}</h2>

          </div>
          <svg className={`sm:hidden ${item.bientot && 'hidden'}  ${item.colorFlech}`} id='group' width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
           <path d="M0 15C0 7.92894 -2.38419e-07 4.3934 2.19669 2.19669C4.3934 -2.38419e-07 7.92894 0 15 0C22.071 0 25.6066 -2.38419e-07 27.8034 2.19669C30 4.3934 30 7.92894 30 15C30 22.071 30 25.6066 27.8034 27.8034C25.6066 30 22.071 30 15 30C7.92894 30 4.3934 30 2.19669 27.8034C-2.38419e-07 25.6066 0 22.071 0 15Z" fill={item.backgroundColor}/>
           <path d="M17 11C17 11 21 13.9459 21 15C21 16.0541 17 19 17 19" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
           <path d="M20.332 15L8.9987 15" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/>
          </svg>


        {item.iconBadges && <img className={`absolute -top-[12px] sm:-top-[10px]  right-[25px] 3xl:right-2 xl:right-[25px] sm:right-2 sm:w-[85px]`} src={item.iconBadges} width={100} height={35} alt=''/>}

      </div>
       
      )
    })}
    </div>
  )
}

export default homeBlockLinks
